export const SIGN_IN = "https://mediumuz.herokuapp.com/auth/sign-in";
export const SIGN_UP = "https://mediumuz.herokuapp.com/auth/sign-up";
export const GET_ACCOUNT = "https://mediumuz.herokuapp.com/api/account/get";
export const GET_POSTS =
  "https://mediumuz.herokuapp.com/api/account/get-my-post";
export const UPDATE_USER = "https://mediumuz.herokuapp.com/api/account/update";
export const GET_MY_POSTS =
  "https://mediumuz.herokuapp.com/api/account/get-my-post";

export const POSTS_API = {
  // GET
  recent: "https://mediumuz.herokuapp.com/api/ghost/post/resent?",
  viewed: "https://mediumuz.herokuapp.com/api/ghost/post/get-most-viewed?",
  rated: "https://mediumuz.herokuapp.com/api/ghost/post/get-most-rated?",
  liked: "https://mediumuz.herokuapp.com/api/ghost/post/get-most-liked?",
  commit: "https://mediumuz.herokuapp.com/api/ghost/post/get-commit?",
  detail: "https://mediumuz.herokuapp.com/api/ghost/post/get-post-body",
  view: "https://mediumuz.herokuapp.com/api/ghost/post/view?id=",
  author: "https://mediumuz.herokuapp.com/api/ghost/account/get?id=",
  search: "https://mediumuz.herokuapp.com/api/ghost/search/post?",
  set_comment: "https://mediumuz.herokuapp.com/api/post/commit",
  comment: "https://mediumuz.herokuapp.com/api/ghost/post/get-commit?",
  get_user: "https://mediumuz.herokuapp.com/api/ghost/account/get?id=",
  user_post: "https://mediumuz.herokuapp.com/api/ghost/post/get-user-post?",
  single_post: "https://mediumuz.herokuapp.com/api/ghost/post/get-post?",
  // DELETE
  delete: "https://mediumuz.herokuapp.com/api/post/delete?id=",
  // Update
  update: "https://mediumuz.herokuapp.com/api/post/update?id=",
};
